"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sources = exports.Sources = void 0;
exports.toSource = toSource;
let Sources = exports.Sources = /*#__PURE__*/function (Sources) {
  Sources[Sources["Unknown"] = 1] = "Unknown";
  Sources[Sources["Web"] = 2] = "Web";
  Sources[Sources["Android"] = 3] = "Android";
  Sources[Sources["IOS"] = 4] = "IOS";
  Sources[Sources["Dashboard"] = 5] = "Dashboard";
  return Sources;
}({});
const sources = exports.sources = [{
  value: Sources.Unknown,
  code: 'UNKNOWN',
  title: 'commons.sources.unknown',
  color: 'rgb(130, 130, 130)',
  icon: 'public-logo',
  default: true
}, {
  value: Sources.Web,
  code: 'WEBSITE',
  title: 'commons.sources.web',
  color: 'rgba(58,142,186,1)',
  icon: 'web-logo'
}, {
  value: Sources.Android,
  code: 'ANDROID',
  title: 'commons.sources.android',
  color: 'rgba(164,198,57,1)',
  icon: 'android-logo'
}, {
  value: Sources.IOS,
  code: 'IPHONE',
  title: 'commons.sources.ios',
  color: 'rgba(206,206,206,1)',
  icon: 'apple-logo'
}, {
  value: Sources.Dashboard,
  code: 'DASHBOARD',
  title: 'commons.sources.dashboard',
  color: 'rgb(126 87 194)',
  icon: 'dashboard-logo'
}];
function toSource(code) {
  return sources.find(source => source.code === code) || sources.find(source => source.default);
}